import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import {
	SalesUserBreadcrumbs,
	SalesEntityModelList
} from '../../../../shared/models/EvoSalesPortalModel';

class Crumb {
	a_style: Object;
	li_style: Object;

	setNotAllowed() {
		this.a_style = Crumb.NOT_ALLOWED_ANCHOR;
		this.li_style = Crumb.NOT_ALLOWED_LISTITEM;
	}
	constructor(public id: number, public name: string) {
		if (Crumb.ELLIPSES_ID === id) {
			this.setNotAllowed();
		}
		this.formatName();
	}

	formatName() {
		if (Crumb.ELLIPSES_ID !== this.id) {
			//this.name = '(' + this.id + ') - ' + this.name;
			this.name = this.name;
		}
	}
}
namespace Crumb {
	export const ELLIPSES_ID = -1;
	export const ELLIPSES_STRING = '...';
	export const NOT_ALLOWED_LISTITEM = { cursor: 'not-allowed' };
	export const NOT_ALLOWED_ANCHOR = {
		cursor: 'not-allowed',
		'pointer-events': 'none'
	};
}

@Component({
	selector: 'app-sales-entity-breadcrumbs',
	templateUrl: './sales-entity-breadcrumbs.component.html',
	styleUrls: ['./sales-entity-breadcrumbs.component.scss']
})
export class SalesEntityBreadcrumbsComponent implements OnInit {
	//#region Fields
	_salesEntityModelList: SalesEntityModelList;
	@Input() isBusy = false;
	@Input() rootNodeName: string;
	@Output()
	breadcrumb_click: EventEmitter<
		SalesEntityBreadcrumbClickArgs
	> = new EventEmitter();

	DEBUG = false;
	crumbs: Array<Crumb> = new Array<Crumb>();
	//#endregion

	//#region Properties
	@Input()
	set salesEntityModelList(input: SalesEntityModelList) {
		this._salesEntityModelList = input;
		this.createCrumbs();
	}
	get salesEntityModelList(): SalesEntityModelList {
		return this._salesEntityModelList;
	}

	public get breadcrumb(): SalesUserBreadcrumbs {
		let result: SalesUserBreadcrumbs = null;
		if (this.salesEntityModelList) {
			if (
				this.salesEntityModelList.BreadCrumbs &&
				this.salesEntityModelList.BreadCrumbs.length > 0
			) {
				result = this.salesEntityModelList.BreadCrumbs[0];
			//	console.log("test" +result);
			} else {
				result = new SalesUserBreadcrumbs();
			}
		}
		return result;
	}
	//#endregion Properties

	//#region Construction
	constructor() {}

	ngOnInit() {
		if (0 === this.breadcrumb_click.observers.length) {
			throw new Error('Output binding (breadcrumb_click) is required.');
		}
		if (!this.salesEntityModelList) {
			throw new Error(
				'Input binding [salesEntityModelList] is required.'
			);
		}
	}

	createCrumbs() {
		if (this.DEBUG) {
			this.debug();
		}
		this.crumbs = [];
		let breadcrumb: SalesUserBreadcrumbs = null;
		if (
			this.salesEntityModelList.BreadCrumbs &&
			this.salesEntityModelList.BreadCrumbs.length > 0
		) {
			breadcrumb = this.salesEntityModelList.BreadCrumbs[0];
		}

		let insertTop = false;
		let insertNestedDirectParent = false;
		let insertDirectParent = false;
		let insertCurrent = false;

		if (breadcrumb) {
			if (
				null === breadcrumb.DirectParentID ||
				breadcrumb.TopLevelID === breadcrumb.DirectParentID
			) {
				insertTop = true;
				/*1.	At a Top-level Sales Entity:
					a.	TopLevel will be the same as Current
					b.	DirectParent will be NULL
					c.	Current will be the same as TopLevel */
			}
			if (breadcrumb.TopLevelID === breadcrumb.DirectParentID) {
				insertDirectParent = true;
				/*2.	Directly under a Top-Level Sales Entity:
					a.	TopLevel will be the same as DirectParent
					b.	DirectParent will be same as TopLevel
					c.	Current will be its own value */
			} else if (breadcrumb.DirectParentID) {
				insertNestedDirectParent = true;
				/*2.	Directly under a Top-Level Sales Entity:
					a.	TopLevel will be the same as DirectParent
					b.	DirectParent will be same as TopLevel
					c.	Current will be its own value */
			}

			if (
				breadcrumb.DirectParentID &&
				breadcrumb.TopLevelID !== breadcrumb.DirectParentID &&
				breadcrumb.DirectParentID !== breadcrumb.CurrentID
			) {
				insertCurrent = true;
				/*3.	Some further number of levels down:
					a.	TopLevel will be its own value
					b.	DirectParent will be its own value
					c.	Current will be its own value */
			}

			if (insertTop) {
				const crumb = new Crumb(
					breadcrumb.TopLevelID,
					breadcrumb.TopLevelName
				);
				this.crumbs.push(crumb);
			}
			if (insertDirectParent) {
				const crumb = new Crumb(
					breadcrumb.CurrentID,
					breadcrumb.CurrentName
				);
				this.crumbs.push(crumb);
			}
			if (insertNestedDirectParent) {
				let crumb = new Crumb(Crumb.ELLIPSES_ID, Crumb.ELLIPSES_STRING);
				this.crumbs.push(crumb);

				crumb = new Crumb(
					breadcrumb.DirectParentID,
					breadcrumb.DirectParentName
				);
				this.crumbs.push(crumb);
			}
			if (insertCurrent) {
				const crumb = new Crumb(
					breadcrumb.CurrentID,
					breadcrumb.CurrentName
				);
				this.crumbs.push(crumb);
			}
		}

		if (this.crumbs.length > 0) {
			const lastNdx = this.crumbs.length - 1;
			this.crumbs[lastNdx].setNotAllowed();
		}
	}

	//#endregion Construction

	emitBreadcrumbClicked(crumb: Crumb) {
		console.log(crumb);
		this.crumbs = this.crumbs.filter(obj => obj !== crumb);
		const args = new SalesEntityBreadcrumbClickArgs(crumb.id, crumb.name);
		this.breadcrumb_click.emit(args);
	}

	public debug() {
		console.log(this._salesEntityModelList);
		if (this.breadcrumb) {
			console.log('     TopLevelID: ' + this.breadcrumb.TopLevelID);
			console.log(' DirectParentID: ' + this.breadcrumb.DirectParentID);
			console.log('      CurrentID: ' + this.breadcrumb.CurrentID);
			console.log('    TopLevelName: ' + this.breadcrumb.TopLevelName);
			console.log(
				'DirectParentName: ' + this.breadcrumb.DirectParentName
			);
			console.log('     CurrentName: ' + this.breadcrumb.CurrentName);
		}
	}
} // class

export class SalesEntityBreadcrumbClickArgs {
	constructor(public id: number, public name?: string) {}
} // class
